import Mutations from '../../odata/mutations';

export default { ...new Mutations('formSignature'), ...new Mutations('formSignatures') };
